import type EmberArray from '@ember/array';
import Controller from '@ember/controller';
import { service } from '@ember/service';
import type AverageMonthlyVisitorCountModel from 'garaje/models/average-monthly-visitor-count';
import type GroupModel from 'garaje/models/group';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type LocationsService from 'garaje/services/locations';
import type SkinnyLocationsService from 'garaje/services/skinny-locations';
import { filterBy } from 'macro-decorators';

interface LocationOverviewLocationsControllerModelWithGroups {
  groups: EmberArray<GroupModel>;
}

type LocationOverviewLocationsControllerModel =
  | LocationOverviewLocationsControllerModelWithGroups
  | EmberArray<AverageMonthlyVisitorCountModel>;

export default class LocationOverviewLocationsController extends Controller {
  declare model: LocationOverviewLocationsControllerModel;

  @service declare featureFlags: FeatureFlagsService;
  @service declare skinnyLocations: SkinnyLocationsService;
  @service declare locations: LocationsService;

  @filterBy('model.groups', 'isNew', false) declare groups: EmberArray<GroupModel>;
}
